module.exports = __webpack_public_path__ + "static/media/xing-square.2d82be25.svg";